<template>
    <div class="row">
        <div class="col fw-bold">
            <div v-if="props.question.header" class="mb-3">{{ props.question.header[participant.language] }}</div>
            <span v-html="props.question.text[participant.language]"></span>
        </div>
    </div>
</template>


<script setup>
    import { storeToRefs } from 'pinia'
    import { useSurveysStore } from '../../../stores/surveys'
    const { participant } = storeToRefs(useSurveysStore())

    const props = defineProps(['question'])
</script>